import { useContext } from 'react';

import { IUserState, UserContext } from 'contexts/user/UserContextProvider';

export default function useUserContext(): IUserState {
  return useContext(UserContext);
}
